import React, { Component } from 'react'

import axios from 'axios'

import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton'

import Icon from 'react-icons-kit'
import { ic_phone as mdIc_phone} from 'react-icons-kit/md/ic_phone'
import { ic_mail as mdIc_mail} from 'react-icons-kit/md/ic_mail'
import { ic_place as mdIc_place} from 'react-icons-kit/md/ic_place'

import BreakPoint from '../../responsive-utilities/breakpoint'
import AspectRatio from '../AspectRatio'

import { Parallax } from 'react-parallax';
// import imgMain from './contact-pic.jpg'

import ReCAPTCHA from 'react-google-recaptcha'

import './style.css'

// const Contact = ({ data }) => {
class Contact extends Component {
  state = {
    isMapFocused: true,
    submitting: false,
    name: '',
    contact_number: '',
    email: '',
    subject: 'General Enquiry',
    message: '',
    recaptchaResponse: '',
  }

  onMapTouchTap = () => {
    return
    if (!this.state.isMapFocused) {
      this.setState({ isMapFocused: true })
    }
  }

  onMouseLeave = () => {
    return
    if (this.state.isMapFocused) {
      this.setState({ isMapFocused: false })
    }
  }
  
  formSubmit = (e) => {
    e.preventDefault()
    console.log(this.state)
    
    const {
      name,
      phone,
      email,
      subject,
      message,
      recaptchaResponse,
      submitting,
    } = this.state

    if (submitting) {
      return
    }

    let newState = {
      errorName: null,
      errorEmail: null,
      errorPhone: null,
    }

    let proceed = true

    if (!name) {
      console.log('invalid name', name)
      newState.errorName = 'Name is required.'
      proceed = false
    }

    if (!email) {
      console.log('invalid email', email)
      newState.errorEmail = 'Email is required.'
      proceed = false
    }

    if (!phone) {
      console.log('invalid phone', phone)
      newState.errorPhone = 'Phone is required.'
      proceed = false
    }

    if (!recaptchaResponse) {
      console.log('invalid recaptchaResponse', recaptchaResponse)
      proceed = false
    }

    if (!proceed) {
      this.setState(newState)
    } else {
      this.setState({ submitting: true })
      
      axios.post([
        this.props.data.api.endpoint,
        'email/send',
      ].join('/'), {
        name,
        email,
        phone,
        subject,
        message,
        recaptchaResponse,
      })
      .then((res) => {
        console.log('email/send', res)
        
        if (res.data.error) {
          alert(res.data.error.message || res.data.error)
          this.setState({ submitting: false })
        } else {
          alert(res.data.success.message)
          this.setState({
            submitting: false,
            name: '',
            contact_number: '',
            email: '',
            subject: 'General Enquiry',
            message: '',
            recaptchaResponse: '',
          })
        }
        
      })
    }
    
    return false
  }

  render() {
    const iframeStyle = {
      border: 0,
      pointerEvents: this.state.isMapFocused? 'auto' : 'none',
    }
    const { data } = this.props
    const gmap_Data = `google-maps${ this.state.isMapFocused? ' active' : '' }`

    return (
      <div className="contact">
        <div className="page-bg">
          <Parallax bgImage="" strength={400} className="page-parallax contact">
            <div className="wrapper">
              <div className={gmap_Data} onClick={this.onMapTouchTap} onMouseLeave={this.onMouseLeave}>
                <BreakPoint query="smUp">
                  {(matches) => {
                  if (matches) {
                    return (
                      <AspectRatio aspectRatio={16/9}>
                        <iframe src={data.googleMapsEmbed}
                          frameBorder="0"
                          style={iframeStyle}
                          allowFullScreen
                          title="Google Maps"
                        ></iframe>
                        <div className="overlay"><div className="overlay-text">View Map</div></div>
                      </AspectRatio>
                    )
                  } else {
                    return (
                      <AspectRatio aspectRatio={1/1}>
                        <iframe src={data.googleMapsEmbed}
                          frameBorder="0"
                          style={iframeStyle}
                          allowFullScreen
                          title="Google Maps"
                        ></iframe>
                        <div className="overlay"><div className="overlay-text">View Map</div></div>
                      </AspectRatio>
                    )
                  }
                }}
                </BreakPoint>
              </div>
            </div>
          </Parallax>
        </div>
        <div className="container container-parallax contact">
          <div className="parallax-container">
            <div className="row">
              <div className="left align-start">
                {/*<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6996.516796169719!2d101.71185810812013!3d3.1534447547003728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc955b08cfc1aae29!2sSuria+KLCC!5e0!3m2!1sen!2smy!4v1499428761525" width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>*/}
                {/* <iframe src={data.googleMapsEmbed}
                  frameBorder="0"
                  allowFullScreen
                  title="Google Maps"
                  className="contact-map"
                ></iframe> */}

                {/* 1F-12, Tower 4 & 5, PFCC,<br/>
                Bandar Puteri Puchong, <br/>
                47100 Puchong, Malaysia. */}
                <div className="address">
                  <div style={{ display: 'flex', justifyContent: 'center', margin: '1rem 0' }}>
                    <div>
                      <Icon icon={mdIc_place} className="contact-icon" size={20} />
                    </div>
                    <div>
                      <a href={data.googleMapsLink} target="_blank" rel="noopener noreferrer">
                        {true && data.address.split('\n').map((item, index) => {
                          return (
                            <div style={{ paddingTop: index === 0 ? 0 : '.25rem' }} key={index}>
                              {item}
                            </div>
                          )
                        })}
                      </a>
                    </div>
                  </div>
                </div>

                <div className="phone">
                  <div style={{ display: 'flex', justifyContent: 'center', margin: '1rem 0' }}>
                    <div>
                      <Icon icon={mdIc_phone} className="contact-icon" size={20} />
                    </div>
                    <div>
                      {
                        data.phone.map((phone, index) => {
                          return (
                            <div style={{ paddingBottom: index === 0 ? '.5rem' : 0 }} key={index}>
                              <a href={`tel:+${ phone.number.replace(/[\D]/g, '') }`}>{phone.number}</a>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </div>

                <div className="email">
                  <div>
                    <Icon icon={mdIc_mail} className="contact-icon" size={20} />
                    <a href={`mailto:${ data.email }`}>{data.email}</a>
                  </div>
                </div>

              </div>
              {true &&
                <div className="right">
                  <div className="form-container">
                    <h2 className="pad-05rem" style={{ margin: 0 }}>
                      How can we assist you?
                    </h2>
                    <div className="form-desc pad-05rem">
                      Please send us your questions or enquiries. We are ready to help.
                    </div>
                    <form onSubmit={this.formSubmit}>
                      <div className="row pad-05rem">
                          <TextField
                            hintText="Name"
                            floatingLabelText="Name"
                            fullWidth={true}
                            name="name"
                            required="true"
                            onChange={(event, name) => this.setState({ name })}
                          />
                      </div>
                      <div className="row ">
                        <div className="left col50 pad-05rem">
                          <TextField
                            hintText="Contact Number"
                            floatingLabelText="Contact Number"
                            fullWidth={true}
                            name="phone"
                            required="true"
                            onChange={(event, phone) => this.setState({ phone })}
                          />
                        </div>
                        <div className="right col50 pad-05rem">
                          <TextField
                            hintText="Email Address"
                            floatingLabelText="Email"
                            fullWidth={true}
                            name="email"
                            type="email"
                            required="true"
                            onChange={(event, email) => this.setState({ email })}
                          />
                        </div>
                      </div>
                      <div className="row pad-05rem">
                        <SelectField
                          floatingLabelText="Subject"
                          value={this.state.subject}
                          onChange={(event, index, subject) => this.setState({ subject })}
                          fullWidth={true}
                          name="subject"
                        >
                          <MenuItem value={'General Enquiry'} primaryText="General Enquiry" />
                          <MenuItem value={'Feedback'} primaryText="Feedback" />
                          <MenuItem value={'Others'} primaryText="Others" />
                        </SelectField>
                      </div>
                      <div className="row pad-05rem">
                        <TextField
                          hintText="Message"
                          floatingLabelText="Message"
                          multiLine={true}
                          rows={2}
                          fullWidth={true}
                          name="message"
                          required="true"
                          onChange={(event, message) => this.setState({ message })}
                        />
                      </div>
                      <div className="row pad-05rem ">
                        <ReCAPTCHA
                          ref={(ref) => {
                            this.recaptcha = ref
                          }}
                          sitekey={this.props.data.recaptcha.sitekey}
                          size="normal"
                          onChange={(recaptchaResponse) => {
                            //console.log('recaptchaResponse', recaptchaResponse)
                            this.setState({ recaptchaResponse })
                          }}
                        />
                      </div>
                      {this.state.recaptchaResponse &&
                        <div className="row pad-05rem ">
                          <FlatButton label="Send"
                            backgroundColor="#2e7dc0"
                            className="button-send"
                            containerElement={<button type="submit" />}
                          />
                        </div>
                      }

                    </form>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact/index.js